import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { PaidInvoiceProvider } from "../contexts/PaidInvoiceContext";
import { DialogProvider } from "../contexts/DialogContext";
import { PlanProvider } from "../contexts/PlanContext";

export const PaidInvoiceComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <PaidInvoiceProvider key={0} />,
        <PlanProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default PaidInvoiceComposer;
